import { hyperdbTriggers } from 'hyperdb-utils';
import httpRequest from '../../../helpers/httpRequest';
import { APP_URL } from '../../../../config';
import * as config from '../../../../config';

const triggers = hyperdbTriggers({ config,
  namespace: 'PROPERTY_REVIEW',
  entryPoint: '/property-reviews',
  collectionName: 'property_reviews',
  querySearchListing: [
    ['date', 'guest_name', 'language', 'validated', ['property', ['name'] ]],
    {
      where: { 'property.id': { ne: null } },
      order: { date: 'desc', 'property.name': 'asc' },
    }
  ],
  successMessageCreate: 'Property review created',
  successMessageUpdate: 'Property review updated',
  successMessageDelete: 'Property review deleted',
});

export default triggers;



// WEBPACK FOOTER //
// ./src/frontend/modules/content/property-review/triggers.js